export function validatePass(val) {
  let regPass = /(?!^(\d+|[a-zA-Z]+|[~!@#$%^&*?]+)$)^[\w~!@#$%^&*?]{8,30}$/;
  return regPass.test(val);
}
export function is_email(value) {
  var pattern = /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
  if (!pattern.test(value)) {
    return false;
  }
  return true;
}

export function is_Phone(value) {
  var pattern = /^1[3456789]\d{9}$/;
  if (!pattern.test(value)) {
    return false;
  }
  return true;
}

export function validateWalletPass(val){
  let regPass = /^[a-zA-Z0-9@#$%^&]{6,40}$/
  return regPass.test(val)
}